module.exports = "/_next/static/images/notification-ca84188c260d320a12a3e0436ced1664.svg";